var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeedback({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6721 1.66992H3.33776C2.42045 1.66992 1.66992 2.42007 1.66992 3.33692V18.3399L4.99725 15.0059H16.6721C17.5894 15.0059 18.3399 14.2558 18.3399 13.3389V3.33692C18.3399 2.42007 17.5894 1.66992 16.6721 1.66992ZM10.8347 11.6719H9.16684V10.0049H10.8347V11.6719ZM10.8347 7.50442C10.8347 7.96285 10.4594 8.33792 10.0008 8.33792C9.5421 8.33792 9.16684 7.96285 9.16684 7.50442V5.83742C9.16684 5.379 9.5421 5.00392 10.0008 5.00392C10.4594 5.00392 10.8347 5.379 10.8347 5.83742V7.50442Z",
    fill: "#66D1FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedback);
export default __webpack_public_path__ + "static/media/feedback.03fe83ed600b758ce0d12e1dc6dc7724.svg";
export { ForwardRef as ReactComponent };